var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import SidebarNavItem from './SidebarNavItem';
import SidebarNavDropdown from './SidebarNavDropdown';
export const SidebarNavLink = ({ isCollapsed, pathname, navMenu }) => {
    const { submenu } = navMenu, rest = __rest(navMenu, ["submenu"]);
    const component = useMemo(() => {
        return submenu ? (_jsx(SidebarNavDropdown, Object.assign({ isCollapsed: isCollapsed, pathname: pathname, submenus: submenu }, rest))) : (_jsx(SidebarNavItem, Object.assign({ isCollapsed: isCollapsed }, rest)));
    }, [isCollapsed, pathname, submenu, rest]);
    return component;
};
